import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';

import { IFeedProps } from '../../types';

import * as styles from './styles.css';

export const Feed: React.FC<IFeedProps> = props => {
  return (
    <table className={styles['table']}>
      <thead>
        <tr>
          <th className={styles['card-row']} />
          <th className={styles['start-row']}>
            <InlineText2 color="black_60">Начальная цена</InlineText2>
          </th>
          <th className={styles['actual-row']}>
            <InlineText2 color="black_60">{props.actualColTitle}</InlineText2>
          </th>
          <th className={styles['valuation-row']}>
            <InlineText2 color="black_60">Оценка от Циан</InlineText2>
          </th>
        </tr>
      </thead>
      <tbody className={styles['table-body']}>{props.rows}</tbody>
    </table>
  );
};

Feed.displayName = 'Feed';
